import { Record, Union } from "./fable_modules/fable-library.4.10.0/Types.js";
import { record_type, string_type, union_type, class_type } from "./fable_modules/fable-library.4.10.0/Reflection.js";
import { noCmd } from "./Common.fs.js";
import { empty } from "./fable_modules/fable-library.4.10.0/Map.js";
import { comparePrimitives } from "./fable_modules/fable-library.4.10.0/Util.js";
import { resultsViewEmb$0027 } from "./MainTemplates.fs.js";

export class Msg extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["Exn"];
    }
}

export function Msg_$reflection() {
    return union_type("AdminResults.Msg", [], Msg, () => [[["Item", class_type("System.Exception")]]]);
}

export class Model extends Record {
    constructor(Errors) {
        super();
        this.Errors = Errors;
    }
}

export function Model_$reflection() {
    return record_type("AdminResults.Model", [], Model, () => [["Errors", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, string_type])]]);
}

export function init(api, user) {
    return noCmd(new Model(empty({
        Compare: comparePrimitives,
    })));
}

export function update(api, user, msg, cm) {
    return noCmd(cm);
}

export function view(dispatch, user, model, contentHost) {
    return resultsViewEmb$0027(true, user.QuizId, user.ResultsToken, void 0, contentHost);
}

